<template>
<div class="chapter">
<div class="inner_page">
<div> <a id="lpn_iv"></a></div>
<p class="copyright1">This digital edition first published by Canongate in 2011</p>
<p class="copyright2">I</p>
<p class="copyright2">Copyright © Olivia Laing, 2011</p>
<p class="copyright2">The moral right of the author has been asserted</p>
<p class="copyright2">First published in Great Britain in 2011 by Canongate Books Ltd,<br/>
  14 High Street, Edinburgh EH1 1TE</p>
<p class="copyright2"><a href="http://www.canongate.tv" target="_blank">www.canongate.tv</a></p>
<p class="copyright2">For permission acknowledgements, please see <span href="#/html/028_permission#acknow2" title="Link target outside of Sample">here</span></p>
<p class="copyright2"><i>British Library Cataloguing-in-Publication Data</i><br/>
  A catalogue record for this book is available on request from the British Library</p>
<p class="copyright2">ISBN 978 1 84767 792 1<br/>
  eISBN 978 0 85786 065 1</p>
<p class="copyright2">Typeset by Palimpsest Book Production Ltd, Falkirk, Stirlingshire</p>
<p class="copyright2">Map of the Ouse copyright © Helen Macdonald, 2011</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003_cr.vue?5209e0d4